import React from "react";
import { Search, ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { TableHead } from "@/components/ui/table";

/**
 * Sortable table header. Click to cycle asc → desc.
 * <SortHeader tf={tf} col="name" className="text-right">Nama</SortHeader>
 */
export function SortHeader({ tf, col, children, className = "", testId }) {
  const active = tf.sort.key === col;
  const dir = active ? tf.sort.dir : null;
  return (
    <TableHead
      onClick={() => tf.toggleSort(col)}
      className={`cursor-pointer select-none hover:bg-slate-100 transition-colors ${className}`}
      data-testid={testId || `sort-${col}`}
      aria-sort={active ? (dir === "asc" ? "ascending" : "descending") : "none"}
      tabIndex={0}
      onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); tf.toggleSort(col); } }}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {dir === "asc" ? <ArrowUp className="w-3 h-3 text-[var(--hotto-primary)]"/> :
         dir === "desc" ? <ArrowDown className="w-3 h-3 text-[var(--hotto-primary)]"/> :
         <ArrowUpDown className="w-3 h-3 text-slate-300"/>}
      </span>
    </TableHead>
  );
}

/**
 * Toolbar with search box. Supports optional right-side actions.
 */
export function TableToolbar({ tf, placeholder = "Cari...", right, testId }) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3">
      <div className="relative flex-1 min-w-[220px] max-w-md">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
        <Input
          value={tf.search}
          onChange={(e) => tf.setSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-8 h-9"
          data-testid={testId || "table-search"}
        />
      </div>
      {right}
    </div>
  );
}
